import { useAuth } from './AuthContext'

// This hook is intended to be used in places where you know for sure that the user is authenticated
export const useClaims = () => {
  const { claims } = useAuth()

  if (!claims) {
    throw new Error('No claims available. User is not authenticated.')
  }

  return claims
}
